/**
 * This helper generates a random hash using Math.random and base36 string conversion.
 * The .substr() removes "0." from the String.
 *
 * @export
 * @returns {String} Random base36 hash
 */
export default function (): string {
  return Math.random().toString(36).substr(2); // remove `0.`
}
